const hostname = window.location.hostname;

export const LISTING_API_SERVER = hostname === "www.xpressdocs.com" ? "https://apm.xpressdocs.com"
: ((hostname.includes("stage") || hostname.includes("mainttre")) ? "https://apm-qa.xpressdocs.com" : "https://apm-dev.xpressdocs.com");
export const IMGPROXY_SERVER = hostname === "www.xpressdocs.com" ? "https://imgproxy.xpressdocs.com" : "https://imgproxy-stagetre.xpressdocs.com";
export const CC_CONFIG_URL                      = `/xdapi/api/cc-configs`;
export const CC_TEMPLATE_JSON_URL               = `/xdapi/api/upload-template-json`;
export const CC_TEMPLATE_PATH_URL               = `/xdapi/api/template-path`;
export const CC_GET_TEMPLATE_BY_PATH_URL        = `/xdapi/api/get-template-by-path`;
export const CC_UPDATE_TEMPLATE_PATH_URL        = `/xdapi/api/update-template-path`;
export const CC_TEMPLATE_UPLOAD_FILES_URL       = `/xdapi/api/upload-template-files`;
export const CC_GET_IDML_ATTRIBUTES_URL         = `/xdapi/api/get-idml-attributes`;
export const CC_TEMPLATE_DOWNLOAD_ZIP_FILE_URL  = `/xdapi/api/download-template-zip-file`;
export const CC_XD_TEMPLATE_TO_CC_CONFIG_URL    = `/xdapi/api/xd-template-to-cc-config`;
export const CC_TEMPLATE_CLEAR_FILES_URL        = `/xdapi/api/clear-template-location`;
export const CC_COLOR_URL                       = `/xdapi/api/color`;
export const CC_STYLE_URL                       = `/xdapi/api/styles`;
export const CC_FONTS_URL                       = `/xdapi/api/get-fonts`;
export const CC_AUDIT_URL                       = `/xdapi/api/audit-log-json`;
export const CC_HARD_CLONE_SURFACE              = `/xdapi/api/hard-clone-surface`;
export const CC_GET_RELATED_TEMPLATES           = `/xdapi/api/get-related-templates`;
export const CC_REFRESH_TEMPLATE_THUMBNAILS     = `/xdapi/api/template-thumbnail`;
export const CC_GET_PLUGIN_LIST                 = `/xdapi/api/get-plugin-list`;
export const CC_DOWNLOAD_PLUGIN                 = `/xdapi/api/download-plugin`;
export const CC_UPLOAD_PLUGIN                   = `/xdapi/api/upload-plugin`;
export const CC_VERSIONS                        = `/xdapi/api/versions`;
export const CC_HOST_URL                        = `/xdapi/api/get-host`;
export const LISTING_RULE_URL                   = `${LISTING_API_SERVER}/cc-rule-types`;
export const LISTING_RULE_MANAGER_URL           = `${LISTING_API_SERVER}/cc-rule-creations`;
export const COLOR_SET_URL                      = `${window.location.origin}/next-api/colorSets`;
export const DEFAULT_BINDINGS_URL               = `${window.location.origin}/next-api/template-default-bindings`;
export const MOCK_DATA_URL                      = `${window.location.origin}/next-api/mock-data`;
export const SYSTEM_CONSTANTS_URL               = `${window.location.origin}/next-api/system-constants`;
export const TEMPLATE_ADMIN_URL                 = `${window.location.origin}/next-api/templateAdmin`;

export const CC_INTERNAL_TOKEN_URL              = `/xdapi/api/get-internal-cc-token`;
export const CC_TEMPLATE_INFO                   = `/xdapi/api/get-xd-template-information`;
export const CC_TEMPLATE_INFO_BY_CCCONFIG       = `/xdapi/api/get-xd-template-information-by-ccconfig`;

export const USERS_PC_TEAM                      = "bwilson,bcook,bmitchell,dmcmullen,msadowski,tecra_nbasha,gfl_ntyshchenko";

export const CC_API_USERNAME                    = `ccApiSecretUser`;
export const CC_API_PASSWORD                    = `dce708005e5740c4bf1420f7643271c0`;

export const LISTING_API_USERNAME               = `xpressdocs`;
export const LISTING_API_PASSWORD               = `poh@z5Ohpea8eeP4Desohh0A`;

export const CC_SETUP_USER_ID                   = "00000000-this-is00-the0-setup0user00";
